/**
 * Phone number validation
 *
 * Mirrors RestApi::validate_phone() so a number rejected here is rejected server-side too.
 *
 * @package
 */

// Grouping characters people actually type, plus a leading + for international numbers.
const ALLOWED_CHARACTERS = /^\+?[\d\s().-]+$/;

const MIN_DIGITS = 7;

// E.164 caps a full international number at 15 digits.
const MAX_DIGITS = 15;

/**
 * Check that a phone number is made of digits and ordinary grouping characters.
 *
 * @param {string} value Raw field value.
 * @return {boolean} True when the value could be dialled.
 */
export const isValidPhone = value => {
	const trimmed = ( value || '' ).trim();

	if ( ! ALLOWED_CHARACTERS.test( trimmed ) ) {
		return false;
	}

	const digitCount = trimmed.replace( /\D/g, '' ).length;

	return digitCount >= MIN_DIGITS && digitCount <= MAX_DIGITS;
};
